import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationItemImportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/ItemImport/ItemImportForm")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationItemImport"
				RenderedComponent={this.RenderedComponent}
				context="generalItem"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationItemImportActivity)
